/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spaces_Credentials_DescriptionInputs */



/**
* | output |
* | --- |
* | "Enter a new value only for what you want to change. Empty fields keep their current value." |
*
* @param {Spaces_Credentials_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_credentials_description = /** @type {((inputs?: Spaces_Credentials_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_Credentials_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Gib nur dort einen neuen Wert ein, wo du etwas ändern möchtest. Leere Felder behalten ihren aktuellen Wert.")
	return /** @type {LocalizedString} */ ("Enter a new value only for what you want to change. Empty fields keep their current value.")
});